require('./email-templete.component.scss');
class EmailTempleteController {
  constructor(
    $scope,
    $element,
    $http,
    $timeout,
  ) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.filterReady = false;
    this.subjectTemplate = this.$scope.filter.email_subject_template;
    this.bodyTemplate = this.$scope.filter.email_body_template;
    $.get('/static/analytics/templates/notify_subject.html', (data) => {
      this.defaultSubjectTemplate = data;
      if (!this.$scope.filter.email_subject_template )
        this.subjectTemplate = this.defaultSubjectTemplate;
      this.$scope.$apply();
      // console.log(data);
    });

    $.get('/static/analytics/templates/notify.html', (data) => {
      this.defaultBodyTemplate = data;
      if (!this.$scope.filter.email_body_template)
        this.bodyTemplate = this.defaultBodyTemplate;
      this.$scope.$apply();
    });
  }

  acceptTemplete() {
    if (this.subjectTemplate !== this.defaultSubjectTemplate ||
      this.bodyTemplate !== this.defaultBodyTemplate) {
      this.$scope.filter.email_subject_template = this.subjectTemplate;
      this.$scope.filter.email_body_template = this.bodyTemplate;
    } else {
      delete this.$scope.filter.email_subject_template;
      delete this.$scope.filter.email_body_template;
    }
    this.$scope.emailTemplete.show = false;
  }

  defaultTemplete() {
    this.subjectTemplate = this.defaultSubjectTemplate;
    this.bodyTemplate = this.defaultBodyTemplate;
    delete this.$scope.filter.email_subject_template;
    delete this.$scope.filter.email_body_template;
  }

  cancelTemplete() {
    this.$scope.emailTemplete.show = false;
  }

}

export function EmailTempleteComponent() {
  return {
    restrict: 'E',
    template: require('./email-templete.component.html'),
    scope: false,
    controller: EmailTempleteController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/email-templete/email-templete.component.js